import bg from './bg'
import cz from './cz'
import de from './de'
import el from './el'
import en from './en'
import esCl from './es-cl'
import fr from './fr'
import hu from './hu'
import nl from './nl'
import it from './it'
import pl from './pl'
import pt from './pt'
import ptBR from './pt-br'
import ro from './ro'
import ru from './ru'
import sk from './sk'
import tr from './tr'

export default {
  bg,
  cz,
  de,
  el,
  en,
  'es-CL': esCl,
  fr,
  hu,
  nl,
  it,
  pl,
  ro,
  ru,
  pt,
  'pt-BR': ptBR,
  sk,
  tr,
}
